<template>
    <div class="pa-4">
        <LinkList :data="data"/>
    </div>
</template>

<script>
import LinkList from './LinkList';
export default {
    name: "ReportList",
    components: { LinkList },
    computed: {
        data() {
            return [
                { title: this.$t("malfaction_report_summary"), to: "/reports/malfactions-summary" },
                { title: this.$t("malfaction_report_by_truck_type"), to: "/reports/malfactions-report-by-truck-type" },
                { title: this.$t("malfaction_report_by_truck"), to: "/reports/malfactions-report-by-truck" },
                { title: this.$t("malfaction_report_by_truck_plant"), to: "/reports/malfactions-report-by-truck-plate" },

            ];
        }
    }
}
</script>

<style>

</style>